import React from 'react';
import { ItineraryImage } from './items/ItineraryImage';
import { ItineraryTypes } from './types';

export interface iItineraryHeaderProps {
  upload: ItineraryTypes['ItineraryImageUploadOrThumbnail'];
  title: string;
  subtitles?: string[];
}

export const ItineraryHero = (props: iItineraryHeaderProps) => {
  return (
    <div className="relative w-full h-[500px] overflow-hidden">
      {/* Background Image */}
      <ItineraryImage className="h-full" index={0} upload={props.upload} />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-30" />

      {/* Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-4">
        <h1 className="font-noe-display uppercase tracking-wider mb-4 md:mb-6" style={{ fontSize: '60px' }}>
          {props.title}
        </h1>

        <div className="text-lg md:text-xl space-y-1">
          {props.subtitles?.map((subtitle, index) => (
            <span className="font-noe-display block" key={index}>
              {subtitle}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
